import { useState } from "react";
import Styles from "./CustomAccordion.module.css";
import { Box, Image, Text } from "@chakra-ui/react";
import CustomToolTip from "../../atoms/chakraHelpers/customToolTip";
import accordion_images from "../../../utils/accordion/accordion_images";
import { ProgressStatusIcons } from "../../../utils/accordion/accordionHelper";

const CustomAccordionItem = ({
  item,
  index,
  setTaskType,
  onClick,
  isChapterEndAssessment
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const subtopicNames = item?.taskAttributes?.subtopicList?.
  map((subtopic) => subtopic?.name)?.
  filter((name) => name)?.
  join(", ");
  return (
    <Box
      className={Styles.mainContainer}
      onClick={() => {
        setTaskType(item?.taskType);
        onClick(item?.taskType, isChapterEndAssessment, index, item?.taskType);
      }}
      key={index}>

      <Box className={Styles.leftContainer}>
        {item?.taskStatus === "completed" ?
        <Image
          className={Styles.leftContainerImage}
          src={accordion_images.subTopicTasksCompleted}
          alt="Completed Homwework" /> :


        <Image
          className={Styles.leftContainerImage}
          src={ProgressStatusIcons(item?.taskType, item?.taskStatus)}
          alt="Homework Status" />

        }
        <Text className={Styles.assessmentText}>Assessment Practice</Text>
      </Box>
      <CustomToolTip
        data={subtopicNames}
        icon={accordion_images.customSubtopicInfo}
        variant={"AccordionIcon"} />

    </Box>);

};

export default CustomAccordionItem;